import ViewLessonPlan from "./ViewLessonPlan";

export default ViewLessonPlan